import ProcurementOverview from './pages/ProcurementOverview';
import ProcurementSuppliers from './pages/ProcurementSuppliers';
import ProcurementPurchaseRequests from './pages/ProcurementPurchaseRequests';
import ProcurementPurchaseOrders from './pages/ProcurementPurchaseOrders';
import ProcurementReceiving from './pages/ProcurementReceiving';
import ProcurementSupplierInvoices from './pages/ProcurementSupplierInvoices';
import ProcurementSettings from './pages/ProcurementSettings';
import HoldingAccounting from './components/HoldingAccounting';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HoldingOverview from './pages/HoldingOverview';
import CompanyManagement from './pages/CompanyManagement';
import CompanyDashboard from './pages/CompanyDashboard';
import CompanyOverview from './pages/CompanyOverview';
import Register from './authentication/Register';
import Login from './authentication/Login';
import WorkspaceLayout from './components/WorkspaceLayout';
import SessionGate from './components/SessionGate';
import RequireCompany from './components/RequireCompany';
import CompanyCreate from './pages/CompanyCreate';
import HrManagement from './pages/HrManagement';
import './App.css';
import Leaves from './pages/Leaves';
import Payroll from './pages/Payroll';
import HrProfileList from './pages/HrProfileList';
import DepartmentList from './pages/DepartmentList';
import PositionList from './pages/PositionList';
import PositionLevelList from './pages/PositionLevelList';
import WorkScheduleList from './pages/WorkScheduleList';
import ProfileList from './pages/ProfileList';
import CompanyEdit from './pages/CompanyEdit';
import UnitTypeList from './pages/UnitTypeList';  
import ScheduledChangesList from './pages/ScheduledChangesList';
import OrgChart from './pages/OrgChart';
import PendingActions from './pages/PendingActions';
import PayrollList from './pages/PayrollList';
import NotificationsList from './pages/NotificationsList';
import UsersList from './pages/UsersList';
import UserProfile from './pages/UserProfile';
import EmployeeProfile from './pages/EmployeeProfile';
import AttendanceTimesheet from './pages/AttendanceTimesheet';
import LeaveManagement from './pages/LeaveManagement';
import PayrollCompensation from './pages/PayrollCompensation';
import InsuranceTracking from './pages/InsuranceTracking';
import HrOverview from './pages/HrOverview';
import OutsourcingOverview from './pages/OutsourcingOverview';
import OutsourcingPrivateProjects from './pages/OutsourcingPrivateProjects';
import OutsourcingClients from './pages/OutsourcingClients';
import OutsourcingServices from './pages/OutsourcingServices';
import OutsourcingAssignments from './pages/OutsourcingAssignments';
import OutsourcingBilling from './pages/OutsourcingBilling';
import OutsourcingBillingHistory from './pages/OutsourcingBillingHistory';
import OutsourcingAccounting from './pages/OutsourcingAccounting';
import QaOverview from './pages/QaOverview';
import QaProjectDetail from './pages/QaProjectDetail';
import QaSubprojectDetail from './pages/QaSubprojectDetail';
import QaWorkspace from './pages/QaWorkspace';
import QaTicketDetail from './pages/QaTicketDetail';
import QaExportHistory from './pages/QaExportHistory';
import LeadsOverview from './pages/LeadsOverview';
import LeadDirectory from './pages/LeadDirectory';
import LeadDetail from './pages/LeadDetail';
import LeadPipeline from './pages/LeadPipeline';
import LeadActivities from './pages/LeadActivities';
import LeadProposals from './pages/LeadProposals';
import LeadSources from './pages/LeadSources';
import LeadSettings from './pages/LeadSettings';
import LeadAuditHistory from './pages/LeadAuditHistory';
import FinancialOverview from './pages/FinancialOverview';
import FinancialProjects from './pages/FinancialProjects';
import FinancialPayers from './pages/FinancialPayers';
import FinancialReceivables from './pages/FinancialReceivables';
import FinancialPayees from './pages/FinancialPayees';
import FinancialPayables from './pages/FinancialPayables';
import FinancialTransactions from './pages/FinancialTransactions';
import FinancialDuePayments from './pages/FinancialDuePayments';
import FinancialReports from './pages/FinancialReports';
import FinancialSettings from './pages/FinancialSettings';
import FinancialPettyCash from './pages/FinancialPettyCash';
import ServicesOverview from './pages/ServicesOverview';
import ServiceCatalog from './pages/ServiceCatalog';
import ServiceEngagements from './pages/ServiceEngagements';
import ServiceCategories from './pages/ServiceCategories';
import ServiceAnalytics from './pages/ServiceAnalytics';
import ServiceSettings from './pages/ServiceSettings';
import ProjectOverview from './pages/ProjectOverview';
import ProjectDirectory from './pages/ProjectDirectory';
import ProjectDetail from './pages/ProjectDetail';
import ProjectTasks from './pages/ProjectTasks';
import ProjectMilestones from './pages/ProjectMilestones';
import ProjectTeam from './pages/ProjectTeam';
import ProjectDeliverables from './pages/ProjectDeliverables';
import ProjectTimeTracking from './pages/ProjectTimeTracking';
import ProjectFinancial from './pages/ProjectFinancial';
import ProjectSettings from './pages/ProjectSettings';
import ClientOverview from './pages/ClientOverview';
import ClientDirectory from './pages/ClientDirectory';
import ClientProfile from './pages/ClientProfile';
import ClientContacts from './pages/ClientContacts';
import ClientServices from './pages/ClientServices';
import ClientActivity from './pages/ClientActivity';
import ClientSettings from './pages/ClientSettings';
import InvoiceOverview from './pages/InvoiceOverview';
import InvoiceList from './pages/InvoiceList';
import InvoiceDetail from './pages/InvoiceDetail';
import InvoiceSettings from './pages/InvoiceSettings';
import BoostOverview from './pages/BoostOverview';
import BoostEntries from './pages/BoostEntries';
import BoostSettings from './pages/BoostSettings';
import OrderOverview from './pages/OrderOverview';
import OrderList from './pages/OrderList';
import OrderFulfillment from './pages/OrderFulfillment';
import OrderSettings from './pages/OrderSettings';
import CommissionOverview from './pages/CommissionOverview';
import CommissionProfiles from './pages/CommissionProfiles';
import CommissionRules from './pages/CommissionRules';
import CommissionAgreements from './pages/CommissionAgreements';
import CommissionEntries from './pages/CommissionStudentEntries';
import CommissionBeneficiaries from './pages/CommissionBeneficiaries';
import CommissionSettlements from './pages/CommissionSettlements';
import CommissionAdjustments from './pages/CommissionAdjustments';
import CommissionHistory from './pages/CommissionHistory';
import CommissionSettings from './pages/CommissionSettings';
import AcademyOverview from './pages/AcademyOverview';
import AcademyCategories from './pages/AcademyCategories';
import AcademyBootcampTypes from './pages/AcademyBootcampTypes';
import AcademyCohorts from './pages/AcademyCohorts';
import AcademyStudents from './pages/AcademyStudents';
import AcademyEnrollments from './pages/AcademyEnrollments';
import AcademyCalendar from './pages/AcademyCalendar';
import AcademyAttendance from './pages/AcademyAttendance';
import AcademyAssessments from './pages/AcademyAssessments';
import AcademyInstructors from './pages/AcademyInstructors';
import AcademyContracts from './pages/AcademyContracts';
import AcademyPayments from './pages/AcademyPayments';
import AcademyFinance from './pages/AcademyFinance';
import AcademyCertificates from './pages/AcademyCertificates';
import AcademyDocuments from './pages/AcademyDocuments';
import AcademyHistory from './pages/AcademyHistory';
import AcademySettings from './pages/AcademySettings';
import InventoryOverview from './pages/InventoryOverview';
import InventoryProducts from './pages/InventoryProducts';
import InventoryCategories from './pages/InventoryCategories';
import InventoryWarehouses from './pages/InventoryWarehouses';
import InventoryMovements from './pages/InventoryMovements';
import InventoryCounts from './pages/InventoryCounts';
import InventoryAdjustments from './pages/InventoryAdjustments';
import InventoryReservations from './pages/InventoryReservations';
import InventoryTransfers from './pages/InventoryTransfers';
import InventoryPicking from './pages/InventoryPicking';
import InventoryReturns from './pages/InventoryReturns';
import InventoryHistory from './pages/InventoryHistory';
import InventorySettings from './pages/InventorySettings';
import CertificateVerify from './pages/CertificateVerify';
import RpOverview from './pages/RpOverview';
import RpPositions from './pages/RpPositions';
import RpUsers from './pages/RpUsers';
import RpGrants from './pages/RpGrants';
import RpTimedAccess from './pages/RpTimedAccess';
import RpHistory from './pages/RpHistory';
import RpSettings from './pages/RpSettings';


function AppContent() {
  const location = useLocation();

  const isAuthPage = location.pathname === '/login' || location.pathname === '/register' || location.pathname.startsWith('/verify-certificate/');

  return (
    <WorkspaceLayout showNavigation={!isAuthPage}>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-certificate/:token" element={<CertificateVerify />} />
          <Route path="/" element={<HoldingOverview />} />
          <Route path="/companies" element={<CompanyManagement />} />
          <Route path="/dashboard/:id" element={<CompanyDashboard />} />
          <Route path="/dashboard/:id/overview" element={<CompanyOverview />} />
          <Route path="/companies/create" element={<CompanyCreate />} />
          <Route path="/companies/edit/:id" element={<CompanyEdit />} />
          <Route path="/hr-management" element={<HrManagement />} />
          <Route path="/hr/leaves" element={<Leaves />} />
          <Route path="/hr/payrolls" element={<Payroll />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/:id" element={<UserProfile />} />
          <Route path="/employees/:id" element={<EmployeeProfile />} />

          {/* All /company/* routes require a company to be selected */}
            <Route path="/holding/finance" element={<HoldingAccounting><FinancialOverview /></HoldingAccounting>} />
            <Route path="/holding/finance/projects" element={<HoldingAccounting><FinancialProjects /></HoldingAccounting>} />
            <Route path="/holding/finance/payers" element={<HoldingAccounting><FinancialPayers /></HoldingAccounting>} />
            <Route path="/holding/finance/receivables" element={<HoldingAccounting><FinancialReceivables /></HoldingAccounting>} />
            <Route path="/holding/finance/payees" element={<HoldingAccounting><FinancialPayees /></HoldingAccounting>} />
            <Route path="/holding/finance/payables" element={<HoldingAccounting><FinancialPayables /></HoldingAccounting>} />
            <Route path="/holding/finance/transactions" element={<HoldingAccounting><FinancialTransactions /></HoldingAccounting>} />
            <Route path="/holding/finance/due-payments" element={<HoldingAccounting><FinancialDuePayments /></HoldingAccounting>} />
            <Route path="/holding/finance/reports" element={<HoldingAccounting><FinancialReports /></HoldingAccounting>} />
            <Route path="/holding/finance/settings" element={<HoldingAccounting><FinancialSettings /></HoldingAccounting>} />
            <Route path="/holding/finance/petty-cash" element={<HoldingAccounting><FinancialPettyCash /></HoldingAccounting>} />
          <Route element={<RequireCompany />}>
            <Route path="/company/hr-profiles" element={<HrProfileList />} />
            <Route path="/company/employees" element={<ProfileList />} />
            <Route path="/company/departments" element={<DepartmentList />} />
            <Route path="/company/positions" element={<PositionList />} />
            <Route path="/company/position-levels" element={<PositionLevelList />} />
            <Route path="/company/work-schedules" element={<WorkScheduleList />} />
            <Route path="/company/unit-types" element={<UnitTypeList />} />
            <Route path="/company/scheduled-changes" element={<ScheduledChangesList />} />
            <Route path="/company/org-chart" element={<OrgChart />} />
            <Route path="/company/pending-actions" element={<PendingActions />} />
            <Route path="/company/hr-payroll" element={<PayrollList />} />
            <Route path="/company/notifications" element={<NotificationsList />} />
            <Route path="/company/attendance" element={<AttendanceTimesheet />} />
            <Route path="/company/leave-management" element={<LeaveManagement />} />
            <Route path="/company/payroll" element={<PayrollCompensation />} />
            <Route path="/company/insurance" element={<InsuranceTracking />} />
            <Route path="/company/hr-overview" element={<HrOverview />} />
            <Route path="/company/outsourcing/overview" element={<OutsourcingOverview />} />
            <Route path="/company/outsourcing/private-projects" element={<OutsourcingPrivateProjects />} />
            <Route path="/company/outsourcing/clients" element={<OutsourcingClients />} />
            <Route path="/company/outsourcing/services" element={<OutsourcingServices />} />
            <Route path="/company/outsourcing/assignments" element={<OutsourcingAssignments />} />
            <Route path="/company/outsourcing/billing" element={<OutsourcingBilling />} />
            <Route path="/company/outsourcing/billing-history" element={<OutsourcingBillingHistory />} />
            <Route path="/company/outsourcing/accounting" element={<OutsourcingAccounting />} />
            <Route path="/company/qa" element={<QaOverview />} />
            <Route path="/company/qa/projects/:projectId" element={<QaProjectDetail />} />
            <Route path="/company/qa/projects/:projectId/subprojects/:subprojectId" element={<QaSubprojectDetail />} />
            <Route path="/company/qa/projects/:projectId/subprojects/:subprojectId/workspace/:sspId" element={<QaWorkspace />} />
            <Route path="/company/qa/projects/:projectId/subprojects/:subprojectId/workspace/:sspId/tickets/:ticketId" element={<QaTicketDetail />} />
            <Route path="/company/qa/projects/:projectId/subprojects/:subprojectId/workspace/:sspId/exports" element={<QaExportHistory />} />
            <Route path="/company/leads" element={<LeadsOverview />} />
            <Route path="/company/leads/directory" element={<LeadDirectory />} />
            <Route path="/company/leads/pipeline" element={<LeadPipeline />} />
            <Route path="/company/leads/activities" element={<LeadActivities />} />
            <Route path="/company/leads/proposals" element={<LeadProposals />} />
            <Route path="/company/leads/sources" element={<LeadSources />} />
            <Route path="/company/leads/settings" element={<LeadSettings />} />
            <Route path="/company/leads/audit" element={<LeadAuditHistory />} />
            <Route path="/company/leads/:leadId" element={<LeadDetail />} />
            <Route path="/company/finance" element={<FinancialOverview />} />
            <Route path="/company/finance/projects" element={<FinancialProjects />} />
            <Route path="/company/finance/payers" element={<FinancialPayers />} />
            <Route path="/company/finance/receivables" element={<FinancialReceivables />} />
            <Route path="/company/finance/payees" element={<FinancialPayees />} />
            <Route path="/company/finance/payables" element={<FinancialPayables />} />
            <Route path="/company/finance/transactions" element={<FinancialTransactions />} />
            <Route path="/company/finance/due-payments" element={<FinancialDuePayments />} />
            <Route path="/company/finance/reports" element={<FinancialReports />} />
            <Route path="/company/finance/settings" element={<FinancialSettings />} />
            <Route path="/company/finance/petty-cash" element={<FinancialPettyCash />} />
            <Route path="/company/services" element={<ServicesOverview />} />
            <Route path="/company/services/catalog" element={<ServiceCatalog />} />
            <Route path="/company/services/engagements" element={<ServiceEngagements />} />
            <Route path="/company/services/categories" element={<ServiceCategories />} />
            <Route path="/company/services/analytics" element={<ServiceAnalytics />} />
            <Route path="/company/services/settings" element={<ServiceSettings />} />
            <Route path="/company/projects" element={<ProjectOverview />} />
            <Route path="/company/projects/directory" element={<ProjectDirectory />} />
            <Route path="/company/projects/settings" element={<ProjectSettings />} />
            <Route path="/company/projects/:projectId" element={<ProjectDetail />} />
            <Route path="/company/projects/:projectId/tasks" element={<ProjectTasks />} />
            <Route path="/company/projects/:projectId/milestones" element={<ProjectMilestones />} />
            <Route path="/company/projects/:projectId/team" element={<ProjectTeam />} />
            <Route path="/company/projects/:projectId/deliverables" element={<ProjectDeliverables />} />
            <Route path="/company/projects/:projectId/time" element={<ProjectTimeTracking />} />
            <Route path="/company/projects/:projectId/financial" element={<ProjectFinancial />} />
            <Route path="/company/clients" element={<ClientOverview />} />
            <Route path="/company/clients/directory" element={<ClientDirectory />} />
            <Route path="/company/clients/settings" element={<ClientSettings />} />
            <Route path="/company/clients/:clientId" element={<ClientProfile />} />
            <Route path="/company/clients/:clientId/contacts" element={<ClientContacts />} />
            <Route path="/company/clients/:clientId/services" element={<ClientServices />} />
            <Route path="/company/clients/:clientId/activity" element={<ClientActivity />} />
            <Route path="/company/invoicing" element={<InvoiceOverview />} />
            <Route path="/company/invoicing/invoices" element={<InvoiceList />} />
            <Route path="/company/invoicing/invoices/:invoiceId" element={<InvoiceDetail />} />
            <Route path="/company/invoicing/settings" element={<InvoiceSettings />} />
            <Route path="/company/boosts" element={<BoostOverview />} />
            <Route path="/company/boosts/entries" element={<BoostEntries />} />
            <Route path="/company/boosts/settings" element={<BoostSettings />} />
            <Route path="/company/orders" element={<OrderOverview />} />
            <Route path="/company/orders/list" element={<OrderList />} />
            <Route path="/company/orders/fulfillment" element={<OrderFulfillment />} />
            <Route path="/company/orders/settings" element={<OrderSettings />} />
            <Route path="/company/commissions" element={<CommissionOverview />} />
            <Route path="/company/commissions/profiles" element={<CommissionProfiles />} />
            <Route path="/company/commissions/rules" element={<CommissionRules />} />
            <Route path="/company/commissions/agreements" element={<CommissionAgreements />} />
            <Route path="/company/commissions/entries" element={<CommissionEntries />} />
            <Route path="/company/commissions/beneficiaries" element={<CommissionBeneficiaries />} />
            <Route path="/company/commissions/settlements" element={<CommissionSettlements />} />
            <Route path="/company/commissions/adjustments" element={<CommissionAdjustments />} />
            <Route path="/company/commissions/history" element={<CommissionHistory />} />
            <Route path="/company/commissions/settings" element={<CommissionSettings />} />
            <Route path="/company/academy" element={<AcademyOverview />} />
            <Route path="/company/academy/categories" element={<AcademyCategories />} />
            <Route path="/company/academy/bootcamp-types" element={<AcademyBootcampTypes />} />
            <Route path="/company/academy/cohorts" element={<AcademyCohorts />} />
            <Route path="/company/academy/students" element={<AcademyStudents />} />
            <Route path="/company/academy/enrollments" element={<AcademyEnrollments />} />
            <Route path="/company/academy/calendar" element={<AcademyCalendar />} />
            <Route path="/company/academy/attendance" element={<AcademyAttendance />} />
            <Route path="/company/academy/assessments" element={<AcademyAssessments />} />
            <Route path="/company/academy/instructors" element={<AcademyInstructors />} />
            <Route path="/company/academy/contracts" element={<AcademyContracts />} />
            <Route path="/company/academy/payments" element={<AcademyPayments />} />
            <Route path="/company/academy/finance" element={<AcademyFinance />} />
            <Route path="/company/academy/certificates" element={<AcademyCertificates />} />
            <Route path="/company/academy/documents" element={<AcademyDocuments />} />
            <Route path="/company/academy/history" element={<AcademyHistory />} />
            <Route path="/company/academy/settings" element={<AcademySettings />} />
            <Route path="/company/roles-permissions" element={<RpOverview />} />
            <Route path="/company/roles-permissions/positions" element={<RpPositions />} />
            <Route path="/company/roles-permissions/users" element={<RpUsers />} />
            <Route path="/company/roles-permissions/grants" element={<RpGrants />} />
            <Route path="/company/roles-permissions/timed-access" element={<RpTimedAccess />} />
            <Route path="/company/roles-permissions/history" element={<RpHistory />} />
            <Route path="/company/roles-permissions/settings" element={<RpSettings />} />
            <Route path="/company/procurement" element={<ProcurementOverview />} />
            <Route path="/company/procurement/suppliers" element={<ProcurementSuppliers />} />
            <Route path="/company/procurement/purchase-requests" element={<ProcurementPurchaseRequests />} />
            <Route path="/company/procurement/purchase-orders" element={<ProcurementPurchaseOrders />} />
            <Route path="/company/procurement/receiving" element={<ProcurementReceiving />} />
            <Route path="/company/procurement/supplier-invoices" element={<ProcurementSupplierInvoices />} />
            <Route path="/company/procurement/settings" element={<ProcurementSettings />} />
            <Route path="/company/inventory" element={<InventoryOverview />} />
            <Route path="/company/inventory/products" element={<InventoryProducts />} />
            <Route path="/company/inventory/categories" element={<InventoryCategories />} />
            <Route path="/company/inventory/warehouses" element={<InventoryWarehouses />} />
            <Route path="/company/inventory/movements" element={<InventoryMovements />} />
            <Route path="/company/inventory/counts" element={<InventoryCounts />} />
            <Route path="/company/inventory/adjustments" element={<InventoryAdjustments />} />
            <Route path="/company/inventory/reservations" element={<InventoryReservations />} />
            <Route path="/company/inventory/transfers" element={<InventoryTransfers />} />
            <Route path="/company/inventory/picking" element={<InventoryPicking />} />
            <Route path="/company/inventory/returns" element={<InventoryReturns />} />
            <Route path="/company/inventory/history" element={<InventoryHistory />} />
            <Route path="/company/inventory/settings" element={<InventorySettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </WorkspaceLayout>
  );
}

function App() {
  return (
    <Router>
      <SessionGate><AppContent /></SessionGate>
    </Router>
  );
}

export default App;
